/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type CardApplicationResponseStatus = typeof CardApplicationResponseStatus[keyof typeof CardApplicationResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardApplicationResponseStatus = {
  NEW: 'NEW',
  ISSUED: 'ISSUED',
  CANCELLED: 'CANCELLED',
} as const;
